import { urlRs } from "~/utils/url";

import IconDirectionsCar from "~/img/icons/directions_car.svg";

export default function PromoParkingMenu() {
  return (
    <span class="promo-parking-menu">
      <span class="inner">
        <span class="promo-icon">
          <IconDirectionsCar />
        </span>
        <span class="h3">Investissement réduit, rentabilité forte</span>
        <span class="paragraph">
          Profitez d'un large choix de parkings dans toute la France.
        </span>
        <a class="btn" href={urlRs("parkings", "/investir/parkings/")}>
          J’investis
        </a>
      </span>
    </span>
  );
}
